<div class="message-renderer">
  @for (component of components; track $index) {
    @switch (component.type) {
      @case ('header') {
        <app-header [content]="component.content"></app-header>
      }
      @case ('subheader') {
        <app-subheader [content]="component.content"></app-subheader>
      }
      @case ('paragraph') {
        <app-paragraph [content]="component.content"></app-paragraph>
      }
      @case ('list') {
        <app-list [content]="component.content"></app-list>
      }
      @case ('table') {
        <app-table [content]="component.content"></app-table>
      }
      @case ('key_value') {
        <app-key-value [content]="component.content"></app-key-value>
      }
      @case ('user_question') {
        <app-prompt-user
          [prompt]="component.content"
          [disabled]="disabled"
          (send)="onPromptSend($event)"
        ></app-prompt-user>
      }
    }
  }
</div>

